import {RegistrationApiGet, usePutRegistrationByIdMutation} from "./reg_api";
import {Button, Card, CardActions, CardContent, CardMedia, Typography} from "@mui/material";
import userPlaceholder from "/assets/imgs/logo.png";
import {ListCardDataCol} from "../../components/styled";
import Delete from "@mui/icons-material/Delete";
import React from "react";
import useDownloadImage from "../storage/useDownloadImage";
import {useNavigate} from "react-router-dom";


interface Props {
    reg: RegistrationApiGet
}

export default ({reg}: Props) => {

    const avatarUrl = useDownloadImage("machines", reg.workTask?.image_url)
    const [put, {error, isLoading}] = usePutRegistrationByIdMutation()
    const navigate = useNavigate();
    const workTask = reg.workTask;
    return <Card sx={{
        display: "flex",
        backgroundColor: !reg.workTask ?  "error.main": undefined
    }}>
        <CardMedia
            component="img"
            sx={{width: 120, height: 120, minWidth: 120, objectFit: "cover",}}
            image={avatarUrl || userPlaceholder}
            alt={workTask?.Name}
            onClick={() => reg.Status != "RegFinished" && navigate("./operation")}
        />
        <ListCardDataCol>
            <CardContent sx={{width: "100%"}}>
                <Typography variant={"caption"}>Operacija</Typography>
                {workTask && <Typography variant={"h6"}>{workTask.Name}</Typography>}
                {!workTask && <Typography variant={"h6"}>N/A - izberi</Typography>}
                <Typography variant={"body1"}>{workTask?.Code}</Typography>
            </CardContent>
            <CardActions>
                {error && <Typography sx={{color: "red"}}>{error.message}</Typography>}
                {reg.Status != "RegFinished" && reg.workTask && <Button
                    title="Briši stroj"
                    disabled={isLoading}
                    onClick={() => put({id: reg.id, body: {OperationID: null}})}
                ><Delete fontSize={"small"}/> </Button>}

            </CardActions>
        </ListCardDataCol>

    </Card>
}
